import { Site } from '../site';

Site.initializeFoundation();